module.exports = __webpack_public_path__ + "img/257743678.fee0f375.jpg";